module.exports = __webpack_public_path__ + "img/p9.0ee26a37.png";